import { Button, Routing } from './helpers';

function userState(state) {
  return { state: state }
}

export async function detectUserState(programID, abortController) {
  let state = Button.State.loggedOut;
  const response = await fetch(Routing.user, { signal: abortController.signal });
  const userInfo = await response.json();
  const { email = null, programs = [] } = userInfo;

  if (email) {
    state = Button.State.loggedInNonMember;

    if (programID && programs.length > 0) {
      for (let i = 0; i < programs.length; i++) {
        const program = programs[i];

        if (program.id && program.id === programID) {
          state = Button.State.loggedInMember;
          break;
        }
      }
    }
  }

  return userState(state);
}
